/* LBSA 2026 — shop pages: collection filters, product page, rails, feature showcase. Vanilla JS. */
(function () {
  'use strict';
  var d = document, w = window, lbsa = (w.lbsa = w.lbsa || {});
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in w;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function money(c) { return lbsa.money ? lbsa.money(c) : 'R ' + (c / 100).toFixed(2); }
  function withParam(url, k, v) { var u = new URL(url, w.location.origin); u.searchParams.set(k, v); return u.pathname + u.search; }
  function toast(msg) {
    var t = $('.lb-toast'); if (!t) { t = d.createElement('div'); t.className = 'lb-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 3600);
  }
  function openCart() { if (lbsa.cart && lbsa.cart.refresh) lbsa.cart.refresh(true); else w.location.href = '/cart'; }
  function addToCart(body, isForm) {
    return fetch('/cart/add.js', isForm ? { method: 'POST', body: body, headers: { Accept: 'application/json' } }
      : { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }

  /* ---------- quick add on product cards ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lb-quick-add]'); if (!b) return;
    e.preventDefault(); if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    addToCart({ items: [{ id: +b.getAttribute('data-lb-quick-add'), quantity: 1 }] })
      .then(function () { b.classList.remove('is-busy'); b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1600); openCart(); })
      .catch(function (err) { b.classList.remove('is-busy'); toast((err && (err.description || err.message)) || 'Sorry, that could not be added.'); });
  });

  /* ---------- rails ---------- */
  function initRail(wrap) {
    if (wrap._lbRail) return; wrap._lbRail = 1;
    var track = $('[data-lb-rail-track]', wrap), btns = $$('[data-lb-rail-btn]', wrap); if (!track) return;
    function state() { var max = track.scrollWidth - track.clientWidth - 2; btns.forEach(function (b) { b.disabled = +b.getAttribute('data-lb-rail-btn') < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max; }); }
    btns.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: +b.getAttribute('data-lb-rail-btn') * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' }); }); });
    track.addEventListener('scroll', function () { w.requestAnimationFrame(state); }, { passive: true });
    w.addEventListener('resize', state); state();
  }

  /* ---------- recently viewed ---------- */
  var RK = 'lb_recent_v1';
  function recentGet() { try { return JSON.parse(localStorage.getItem(RK) || '[]'); } catch (e) { return []; } }
  function recentPush(h) { try { var a = recentGet().filter(function (x) { return x !== h; }); a.unshift(h); localStorage.setItem(RK, JSON.stringify(a.slice(0, 14))); } catch (e) {} }
  function initRecent(box) {
    if (box._lbRecent) return; box._lbRecent = 1;
    var cur = box.getAttribute('data-current'), lim = +box.getAttribute('data-limit') || 8;
    var list = recentGet().filter(function (h) { return h && h !== cur; }).slice(0, lim);
    if (cur) recentPush(cur);
    if (!list.length) return;
    var track = $('[data-lb-rail-track]', box);
    Promise.all(list.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); }))
      .then(function (htmls) {
        var html = htmls.filter(function (x) { return x.indexOf('lb-card') > -1; }).join('');
        if (!html) return; track.innerHTML = html; box.hidden = false; initRail(box);
      });
  }

  /* ---------- collection: AJAX sort, filters, load more ---------- */
  function initCollection(root) {
    if (root._lbColl) return; root._lbColl = 1;
    var sid = root.getAttribute('data-section'), busy = false, timer;
    function sectionUrl(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid); }
    function get(url) { return fetch(sectionUrl(url), { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); }); }
    function swap(doc) {
      var next = doc.getElementById(root.id); if (!next) return;
      var a = $('[data-lb-coll-results]', root), b = $('[data-lb-coll-results]', next); if (a && b) a.innerHTML = b.innerHTML;
      var fa = $('[data-lb-filter-body]', root), fb = $('[data-lb-filter-body]', next);
      if (fa && fb) {
        var open = $$('details', fa).map(function (x) { return x.open; });
        fa.innerHTML = fb.innerHTML; $$('details', fa).forEach(function (x, i) { if (open[i] !== undefined) x.open = open[i]; });
      }
      var sa = $('.lb-filters__foot [type=submit]', root), sb = $('.lb-filters__foot [type=submit]', next); if (sa && sb) sa.textContent = sb.textContent;
      var hc = $('.lb-phero__meta .lb-chip'), nc = doc.querySelector('.lb-phero__meta .lb-chip'); if (hc && nc) hc.innerHTML = nc.innerHTML;
      bar();
    }
    function load(url, push) {
      if (busy) return; busy = true; root.classList.add('is-loading');
      get(url).then(function (doc) {
        swap(doc);
        if (push !== false) w.history.pushState({ lbColl: 1 }, '', url);
        var top = root.getBoundingClientRect().top + w.scrollY - (parseInt(getComputedStyle(d.documentElement).getPropertyValue('--lb-header-h'), 10) || 72);
        if (w.scrollY > top + 10) w.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      }).catch(function () { w.location.href = url; })
        .then(function () { busy = false; root.classList.remove('is-loading'); });
    }
    function formUrl(form) {
      var p = new URLSearchParams(), fd = new FormData(form);
      fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return form.getAttribute('action') + '?' + p.toString();
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-lb-coll-link]');
      if (a) { e.preventDefault(); load(a.getAttribute('href')); return; }
      var more = e.target.closest('[data-lb-load-more]');
      if (more) {
        e.preventDefault(); if (more.classList.contains('is-busy')) return; more.classList.add('is-busy');
        get(more.getAttribute('href')).then(function (doc) {
          var next = doc.getElementById(root.id), grid = $('[data-lb-coll-grid]', root);
          if (!next || !grid) return;
          $$('[data-lb-coll-grid] > *', next).forEach(function (c, i) { c.style.setProperty('--i', i % 8); grid.appendChild(c); });
          var m = $('[data-lb-coll-more]', root), nm = $('[data-lb-coll-more]', next);
          if (m && nm) m.replaceWith(nm); else if (m) m.remove();
        }).catch(function () { w.location.href = more.getAttribute('href'); });
      }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-lb-sort]')) { load(withParam(w.location.href, 'sort_by', t.value)); return; }
      var form = t.closest('[data-lb-filter-form]');
      if (form) { clearTimeout(timer); timer = setTimeout(function () { load(formUrl(form)); }, t.type === 'number' ? 50 : 320); }
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-lb-filter-form]'); if (!form) return;
      e.preventDefault(); clearTimeout(timer); load(formUrl(form)); if (lbsa.close) lbsa.close();
    });
    w.addEventListener('popstate', function () { load(w.location.href, false); });
    function bar() {
      var b = $('.lb-coll__bar', root); if (!b) return;
      var h = parseInt(getComputedStyle(d.documentElement).getPropertyValue('--lb-header-h'), 10) || 72;
      b.classList.toggle('is-stuck', b.getBoundingClientRect().top <= h + 1 && w.scrollY > 40);
    }
    w.addEventListener('scroll', function () { w.requestAnimationFrame(bar); }, { passive: true }); bar();
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    if (root._lbPP) return; root._lbPP = 1;
    var data; try { data = JSON.parse($('[data-lb-product-json]', root).textContent); } catch (e) { data = null; }
    var labels = ['In stock', 'Available to order']; try { labels = JSON.parse($('[data-lb-product-text]', root).textContent).split('|'); } catch (e) {}
    if (data && data.handle) recentPush(data.handle);

    /* gallery */
    var track = $('[data-lb-track]', root), slides = $$('.lb-pp__slide', root), thumbs = $$('[data-lb-thumb]', root), counter = $('[data-lb-gal-i]', root), gi = 0;
    function mark(i) {
      gi = i; thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: reduce ? 'auto' : 'smooth' }); });
      if (counter) counter.textContent = i + 1;
      slides.forEach(function (s, k) { if (k !== i) $$('video', s).forEach(function (v) { try { v.pause(); } catch (e) {} }); });
    }
    function go(i, instant) { if (!track || !slides.length) return; i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' }); mark(i); }
    if (track) {
      track.addEventListener('scroll', function () { w.requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== gi && slides[i]) mark(i); }); }, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(gi + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(gi - 1); } });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    $$('[data-lb-gal]', root).forEach(function (b) { b.addEventListener('click', function () { go(gi + +b.getAttribute('data-lb-gal')); }); });
    function goMedia(id) { for (var k = 0; k < slides.length; k++) if (+slides[k].getAttribute('data-media-id') === +id) { go(k); return; } }

    /* variants */
    var form = $('[data-lb-product-form]', root), idInput = $('[data-lb-variant-id]', root), atc = $('[data-lb-atc]', root), atcText = $('[data-lb-atc-text]', root), msg = $('[data-lb-atc-msg]', root);
    var priceNow = $('[data-lb-price-now]', root), priceWas = $('[data-lb-price-was]', root), save = $('[data-lb-price-save]', root), stock = $('[data-lb-stock]', root), stockText = $('[data-lb-stock-text]', root), sku = $('[data-lb-sku]', root);
    var sticky = $('[data-lb-sticky]', root), stickyPrice = $('[data-lb-sticky-price]', root), stickyBtn = $('[data-lb-sticky-atc]', root);
    var current = data && data.variants ? (data.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || data.variants[0]) : null;
    function selected() { return $$('[data-lb-option]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function markAvail(sel) {
      if (!data) return;
      $$('[data-lb-option]', root).forEach(function (fs, oi) {
        $$('.lb-opt__v', fs).forEach(function (lab) {
          var val = $('input', lab).value, probe = sel.slice(); probe[oi] = val;
          var ok = data.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === probe[k]; }); });
          lab.classList.toggle('is-na', !ok);
        });
      });
    }
    function render(v) {
      current = v;
      if (!v) { if (atc) { atc.disabled = true; atcText.textContent = 'Unavailable'; } if (stickyBtn) stickyBtn.disabled = true; return; }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) { priceWas.hidden = !sale; if (sale) priceWas.textContent = money(v.compare_at_price); }
      if (save) { save.hidden = !sale; if (sale) save.textContent = 'Save ' + money(v.compare_at_price - v.price).replace(/\.00$/, ''); }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var pre = stock && stock.getAttribute('data-lb-pre');
      var state = !v.available ? 'out' : (pre ? 'pre' : (v.inventory_management === 'shopify' && v.inventory_quantity <= 0 ? 'order' : 'in'));
      if (stock) stock.setAttribute('data-state', state);
      if (stockText) stockText.textContent = state === 'out' ? 'Sold out' : state === 'pre' ? (pre === 'Pre-order' ? pre : 'Pre-order · ' + pre) : (state === 'order' ? (labels[1] || 'Available to order') : (labels[0] || 'In stock'));
      var buy = pre ? 'Pre-order now' : 'Add to cart';
      if (sku) { sku.hidden = !v.sku; sku.textContent = 'SKU ' + (v.sku || ''); }
      if (atc) { atc.disabled = !v.available; atcText.textContent = v.available ? buy : 'Sold out'; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? buy : 'Sold out'; }
      if (v.featured_media && v.featured_media.id) goMedia(v.featured_media.id);
      try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState(w.history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    }
    if (data && data.variants && data.variants.length > 1) {
      root.addEventListener('change', function (e) {
        var fs = e.target.closest('[data-lb-option]'); if (!fs) return;
        var lv = $('[data-lb-opt-val]', fs); if (lv) lv.textContent = e.target.value;
        var sel = selected(), v = data.variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
        render(v); markAvail(sel);
      });
      markAvail(selected());
    }
    if (current && current.featured_media && slides.length) { var k0 = slides.map(function (s) { return +s.getAttribute('data-media-id'); }).indexOf(current.featured_media.id); if (k0 > 0) setTimeout(function () { go(k0, true); }, 30); }

    /* quantity stepper */
    $$('[data-lb-step]', root).forEach(function (st) {
      var inp = $('input', st);
      $$('[data-lb-step-btn]', st).forEach(function (b) { b.addEventListener('click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + +b.getAttribute('data-lb-step-btn')); }); });
    });

    /* add to cart */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (!atc || atc.disabled || atc.classList.contains('is-busy')) return;
      if (msg) msg.textContent = '';
      atc.classList.add('is-busy');
      var fd = new FormData(form); Array.from(fd.keys()).forEach(function (k) { if (k.indexOf('options[') === 0) fd.delete(k); });
      addToCart(fd, true).then(function () {
        atc.classList.remove('is-busy'); atc.classList.add('is-added'); setTimeout(function () { atc.classList.remove('is-added'); }, 1800); openCart();
      }).catch(function (err) {
        atc.classList.remove('is-busy');
        var m = (err && (err.description || err.message)) || 'Sorry, we could not add this to your cart.';
        if (msg) msg.textContent = m; else toast(m);
      });
    });

    /* sticky bar */
    if (sticky && atc && hasIO) {
      new IntersectionObserver(function (ents) {
        var en = ents[0], on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
        d.documentElement.classList.toggle('lb-sticky-on', on);
      }, { threshold: 0 }).observe(atc);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (!form) return; if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    /* copy link */
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lb-copy]'); if (!b) return;
    var txt = b.getAttribute('data-lb-copy');
    (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(function () { b.classList.add('is-copied'); toast('Link copied'); setTimeout(function () { b.classList.remove('is-copied'); }, 1600); }).catch(function () { w.prompt('Copy this link', txt); });
  });

  /* ---------- legacy feature grids → animated hexagon showcase ---------- */
  var hexMod = null;
  function mountHex(el) {
    if (!lbsa.hexSrc || !hasIO) return;
    var io = new IntersectionObserver(function (ents) {
      if (!ents[0].isIntersecting) return; io.disconnect();
      (hexMod || (hexMod = import(lbsa.hexSrc))).then(function (m) { m.mount(el, { intensity: 0.62, tilt: 0.9, scale: 0.95, lift: 0.6 }); }).catch(function () {});
    }, { rootMargin: '300px 0px' });
    io.observe(el);
  }
  function upgradeFeatures(grid) {
    if (grid._lbFx || !$('.feature-card', grid)) return; grid._lbFx = 1;
    var parts = [], prev = grid.previousElementSibling;
    if (prev && prev.matches('p.section-content, p')) { parts.unshift(prev); prev = prev.previousElementSibling; }
    if (prev && prev.matches('.orange-bg-heading, .orange-border-heading, h2, h3')) parts.unshift(prev);
    var fx = d.createElement('div'); fx.className = 'lb-fx';
    fx.innerHTML = '<div class="lb-hexfield" aria-hidden="true"></div><div class="lb-fx__in"><div class="lb-fx__head"><p class="lb-eyebrow">Engineered by LBSA</p></div></div>';
    (parts[0] || grid).parentNode.insertBefore(fx, parts[0] || grid);
    var head = $('.lb-fx__head', fx), inner = $('.lb-fx__in', fx);
    parts.forEach(function (p) { head.appendChild(p); });
    if (!parts.length) head.remove();
    inner.appendChild(grid);
    var cards = $$('.feature-card', grid), n = cards.length;
    cards.forEach(function (c, i) {
      c.classList.add('lb-spot'); c.style.setProperty('--i', i);
      var im = $('.feature-image, img', c);
      if (im) { var m = d.createElement('div'); m.className = 'lb-fx__media'; im.parentNode.insertBefore(m, im); m.appendChild(im); im.loading = 'lazy'; }
      var num = d.createElement('span'); num.className = 'lb-fx__n'; num.textContent = (i < 9 ? '0' : '') + (i + 1); c.appendChild(num);
    });
    if (n > 3 && n % 3 === 2) cards[0].classList.add('is-wide');
    if (n > 3 && n % 3 === 1) { cards[0].classList.add('is-wide'); cards[n - 1].classList.add('is-wide'); }
    if (hasIO && !reduce) new IntersectionObserver(function (ents, o) { if (ents[0].isIntersecting) { fx.classList.add('is-in'); o.disconnect(); } }, { threshold: 0.12 }).observe(grid);
    else fx.classList.add('is-in');
    mountHex($('.lb-hexfield', fx));
    if (fine && !reduce) cards.forEach(function (c) {
      var raf;
      c.addEventListener('pointermove', function (e) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5; c.style.transform = 'translateY(-6px) perspective(900px) rotateY(' + (x * 5).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)'; });
      });
      c.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); c.style.transform = ''; });
    });
  }

  /* ---------- legacy ALL-CAPS copy → sentence case, matching the homepage voice ----------
     Only touches text typed entirely in capitals inside legacy content; acronyms, units and
     brand names are kept. Add data-lb-keep-case to any element that must stay as typed. */
  var KEEP = {}, MAP = {
    SOC: 'SoC', SOH: 'SoH', DOD: 'DoD', ISC: 'Isc', IMP: 'Imp', VMP: 'Vmp', VOC: 'Voc', PMAX: 'Pmax',
    KWH: 'kWh', KW: 'kW', WH: 'Wh', AH: 'Ah', MAH: 'mAh', KVA: 'kVA', LIFEPO4: 'LiFePO4', WIFI: 'Wi-Fi',
    RHINO: 'Rhino', INTELLIFLEX: 'Intelliflex', STORMGUARD: 'Stormguard', INFERNO: 'Inferno', SENTINEL: 'Sentinel',
    FIREBLOCK: 'Fireblock', POWERFLEX: 'PowerFlex', CANADIAN: 'Canadian', SOLIS: 'Solis', SUNSYNK: 'Sunsynk',
    VICTRON: 'Victron', GROWATT: 'Growatt', GOODWE: 'GoodWe', LUXPOWER: 'LuxPower', CHISAGE: 'Chisage', DEYE: 'Deye',
    HUAWEI: 'Huawei', FRONIUS: 'Fronius', SOLAX: 'SolaX', LONGI: 'LONGi', JINKO: 'Jinko', TRINA: 'Trina',
    SOUTH: 'South', AFRICA: 'Africa', AFRICAN: 'African', JOHANNESBURG: 'Johannesburg', PRETORIA: 'Pretoria',
    GAUTENG: 'Gauteng', ESKOM: 'Eskom', I: 'I'
  };
  'LBSA HV LV BMS CAN CE CQC IEC IP NOCT PV STC UART WFRE AC DC USB LED LCD UPS MPPT ESS SA RSA UN MSDS EMS CT PCS RS ISO SABS NRS LFP GSM TUV SMA JA FAQ PDF VSD COC EV OEM'.split(' ').forEach(function (k) { KEEP[k] = 1; });
  function caseWord(t, st) {
    var core = t.replace(/['’]S$/i, ''), tail = t.slice(core.length).toLowerCase(), up = core.toUpperCase();
    if (MAP[up]) { st.first = false; return MAP[up] + tail; }
    if (KEEP[up]) { st.first = false; return up + tail; }
    if (/\d/.test(core)) { if (/[A-Za-z]/.test(core)) st.first = false; return core.replace(/(\d)(KWH|KVA|KW|WH|MAH|AH)$/i, function (m, n, u) { return n + MAP[u.toUpperCase()]; }) + tail; }
    if (core.length === 1) {
      if (up === 'X') return '×';
      if (up !== 'A') return up;
    }
    var lw = core.toLowerCase() + tail;
    if (st.first) { st.first = false; return lw.charAt(0).toUpperCase() + lw.slice(1); }
    return lw;
  }
  var SMALL = { a: 1, an: 1, and: 1, or: 1, of: 1, the: 1, for: 1, to: 1, in: 1, on: 1, with: 1, at: 1, by: 1 };
  var TWO = { of: 1, in: 1, on: 1, at: 1, to: 1, by: 1, an: 1, or: 1, is: 1, it: 1, as: 1, be: 1, do: 1, go: 1, he: 1, if: 1, me: 1, my: 1, no: 1, so: 1, up: 1, us: 1, we: 1 };
  var PART = { van: 1, der: 1, de: 1, du: 1, le: 1, von: 1, den: 1 };
  var WORD = /[\p{L}\p{N}]+(?:[.'’][\p{L}\p{N}]+)*|[.!?:](?=\s|$)/gu;
  function sentenceCase(el, title) {
    var txt = el.textContent;
    if (/\p{Ll}/u.test(txt) || !/\p{Lu}{3}/u.test(txt)) return;
    var st = { first: true }, tw = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, k = 0;
    while ((n = tw.nextNode())) {
      n.nodeValue = n.nodeValue.replace(WORD, function (m) {
        if (/^[.!?:]$/.test(m)) { st.first = true; return m; }
        var lw = m.toLowerCase();
        if (title) {
          if (m.length === 2 && /^\p{Lu}+$/u.test(m) && !TWO[lw]) { k++; st.first = false; return m; }
          if (k > 0 && PART[lw]) { k++; return lw; }
          st.first = k === 0 || !SMALL[lw];
        }
        k++;
        return caseWord(m, st);
      }).replace(/\bCanadian solar\b/g, 'Canadian Solar').replace(/\blithium batteries South Africa\b/gi, 'Lithium Batteries South Africa');
    }
    el.setAttribute('data-lb-cased', '');
    if (/^H[1-4]$/.test(el.tagName) || el.matches('.feature-title,.included-title')) el.style.textTransform = 'none';
  }
  var CASE_SEL = 'h1,h2,h3,h4,h5,p,li,.feature-title,.included-title,.download-name,.single-column-table td,.product-description',
      CASE_SKIP = '.lb-pp-section,.lb-card,.lb-rail-wrap,.lb-recent,.lb-coll,.lb-page-hero,.lb-crumbbar,header,footer,.lb-header,.lb-footer,.lb-layer,[data-lb-keep-case]',
      LBC = '[class^="lb-"],[class*=" lb-"]',
      CASE_OK = 'html,body,.lb-product-page,.lb-fx,.lb-fx__in,.lb-fx__head,.lb-fx__media,.lb-details,.lb-container,.lb-details__grid,.lb-details__main,.lb-details__panel,.lb-prose';
  function fixCase(scope) {
    $$('[data-lb-case]', scope.querySelectorAll ? scope : d).forEach(function (el) { if (!el.hasAttribute('data-lb-cased')) sentenceCase(el, el.getAttribute('data-lb-case') === 'title'); });
    if (!d.body.classList.contains('lb-inner')) return;
    $$(CASE_SEL, scope.querySelector ? (scope.querySelector('#MainContent') || scope) : d).forEach(function (el) {
      if (el.hasAttribute('data-lb-cased') || el.closest(CASE_SKIP)) return;
      var a = el.closest(LBC);
      while (a && a.matches(CASE_OK)) a = a.parentElement ? a.parentElement.closest(LBC) : null;
      if (!a) sentenceCase(el, !!el.closest('.member-content,.team-slider,[class*="team-member"]'));
    });
  }

  /* ---------- cart page: in-place quantity updates, note autosave, terms gate ---------- */
  function initCartPage(root) {
    var sid = root.getAttribute('data-section'), busy = false, noteT;
    function refresh(json) {
      return fetch(w.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html'), next = doc.querySelector('[data-lb-cartpage]');
          var wrap = root.closest('.shopify-section') || root.parentNode;
          if (next) { var sec = doc.body.firstElementChild; wrap.innerHTML = sec && sec.classList.contains('shopify-section') ? sec.innerHTML : doc.body.innerHTML; boot(wrap); }
          if (lbsa.cart && lbsa.cart.render && json) lbsa.cart.render(json); else if (lbsa.cart && lbsa.cart.refresh) lbsa.cart.refresh(false);
        });
    }
    function change(li, qty) {
      if (busy) return; busy = true; li.classList.add('is-busy'); root.classList.add('is-busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +li.getAttribute('data-line'), quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.status && j.status >= 400) throw j; return refresh(j); })
        .catch(function (err) { li.classList.remove('is-busy'); root.classList.remove('is-busy'); toast((err && (err.description || err.message)) || 'Sorry, your cart could not be updated.'); })
        .then(function () { busy = false; });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb-cq]'), rm = e.target.closest('[data-lb-cremove]'), li = e.target.closest('[data-lb-citem]');
      if (b && li) { e.preventDefault(); change(li, Math.max(0, (+li.getAttribute('data-qty') || 0) + +b.getAttribute('data-lb-cq'))); }
      else if (rm && li) { e.preventDefault(); li.classList.add('is-leaving'); change(li, 0); }
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-lb-cq-input]'), li = e.target.closest('[data-lb-citem]');
      if (inp && li) change(li, Math.max(0, parseInt(inp.value, 10) || 0));
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.closest('[data-lb-cq-input]')) { e.preventDefault(); e.target.blur(); } });
    var note = $('[data-lb-cart-note]', root);
    if (note) note.addEventListener('input', function () {
      clearTimeout(noteT);
      noteT = setTimeout(function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(function () {}); }, 500);
    });
    var form = $('[data-lb-cartp-form]', root), terms = $('[data-lb-terms]', root);
    if (form && terms) form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout' && !terms.checked) { e.preventDefault(); terms.closest('label').classList.add('is-err'); terms.focus(); toast('Please accept the terms to continue.'); }
    });
  }

  /* ---------- login: recover pane follows the hash ---------- */
  function syncRecover() {
    var r = d.getElementById('recover');
    if (r && w.location.hash === '#login') r.classList.remove('is-open');
  }
  w.addEventListener('hashchange', syncRecover);

  /* ---------- tabs (product details) ---------- */
  function initTabs(root) {
    var tabs = $$('[data-lb-tab]', root);
    if (tabs.length < 2) return;
    function sel(t, focus) {
      tabs.forEach(function (b) {
        var on = b === t, p = d.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { sel(b); });
      b.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (k) { e.preventDefault(); sel(tabs[(i + k + tabs.length) % tabs.length], true); }
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    try { fixCase(scope); } catch (e) {}
    $$('[data-lb-collection]', scope).forEach(initCollection);
    $$('[data-lb-product]', scope).forEach(initProduct);
    $$('[data-lb-rail]', scope).forEach(initRail);
    $$('[data-lb-recent]', scope).forEach(initRecent);
    $$('[data-lb-tabs]', scope).forEach(initTabs);
    $$('[data-lb-cartpage]', scope).forEach(initCartPage);
    $$('.features-grid', scope).forEach(upgradeFeatures);
  }
  boot(d);
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
